/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_SaveInputs */



/**
* | output |
* | --- |
* | "Switch off" |
*
* @param {Meetings_Exception_SaveInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_save = /** @type {((inputs?: Meetings_Exception_SaveInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_SaveInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zet uit")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Désactiver")
	return /** @type {LocalizedString} */ ("Switch off")
});